// ABOUTME: Embeds the Events On This Day daily history game.
// ABOUTME: Renders an iframe pointing to events.onthis.day.
import React from "react";

const EventsOnThisDayCard: React.FC = () => (
  <div className="rounded-[var(--radius-md)] bg-[var(--color-bg-secondary)] p-0 overflow-hidden w-full h-[480px]">
    <iframe
      src="https://events.onthis.day"
      title="Events On This Day"
      className="w-full h-full border-0"
      loading="lazy"
      allowFullScreen
    />
  </div>
);

export default EventsOnThisDayCard;
